import React from "react";
import colors from "../../theme/colors";
import { Theme } from "../../theme/Theme";
import { Icon } from "@iconify/react";

const AccountInactive = () => {
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
    localStorage.removeItem("auth_phone");
    window.location.href = "/login";
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg-surface, #f8fafc)",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <style>{`
        @keyframes floatY {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-10px); }
        }
        .inactive-icon { animation: floatY 3s ease-in-out infinite; }
      `}</style>

      {/* Icon */}
      <div className="inactive-icon" style={{ marginBottom: 28 }}>
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            background: "var(--color-warning-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            border: "2px solid var(--color-gold)",
          }}
        >
          <Icon icon="ph:lock-simple-bold" width={48} color="var(--color-warning-amber)" />
        </div>
      </div>

      {/* Heading */}
      <h2 style={{ ...Theme.font24SemiBold, color: "var(--text-primary)", marginBottom: 12 }}>
        Account Inactive
      </h2>

      {/* Message */}
      <p
        style={{
          ...Theme.font16Regular,
          color: "var(--text-secondary)",
          maxWidth: 380,
          lineHeight: 1.7,
          marginBottom: 8,
        }}
      >
        Your profile is currently in{" "}
        <span style={{ color: "var(--color-warning-amber)", fontWeight: 700 }}>inactive stage</span>.
        <br />
        You are temporarily blocked from accessing the platform.
      </p>

      {/* Contact customer care */}
      <div
        style={{
          background: "var(--bg-surface)",
          border: "1px solid var(--border-outline)",
          borderRadius: 14,
          padding: "20px 28px",
          maxWidth: 380,
          width: "100%",
          marginTop: 20,
          marginBottom: 28,
          boxShadow: "var(--shadow-surface)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <Icon icon="ph:headset-bold" width={22} color={colors.themeColor} />
          <span style={{ ...Theme.font15SemiBold, color: "var(--text-primary)" }}>
            Contact Customer Care
          </span>
        </div>
        <p style={{ ...Theme.font14Regular, color: "var(--text-secondary)", marginBottom: 0, lineHeight: 1.6 }}>
          If you believe this is a mistake or need assistance,
          please reach out to our support team to resolve your account status.
        </p>
      </div>

      {/* Back to login */}
      <button
        onClick={handleLogout}
        style={{
          background: "transparent",
          border: `1.5px solid ${colors.themeColor}`,
          color: colors.themeColor,
          borderRadius: 10,
          padding: "10px 28px",
          ...Theme.font14SemiBold,
          cursor: "pointer",
        }}
      >
        Back to Login
      </button>
    </div>
  );
};

export default AccountInactive;
